import React from 'react';
import { useTranslation } from "react-i18next";
import ReportPage from '../ReportChart/ReportPage';
import { Apis } from "services/api";
import { getMissingPartsTools } from "services/analytics";
import useChartColors from '../ReportChart/hooks/useChartColors';

const MissingPartsToolsReport = () => {
  const { customCaptions, application } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();
  const { t } = useTranslation();

  const chartConfig = {
    id: 'missing-parts-tools',
    title: application.showParts
      ? t("title.missingPartsAndToolsByReason", { parts: customCaptions.partPlural ?? "Parts", tools: customCaptions.toolPlural })
      : t("title.missingEntityByReason", { entity: customCaptions.toolPlural }),
    fetchData: async (params) => {
      return await getMissingPartsTools(params);
    },
    allowedChartTypes: ['vertical-bar', 'horizontal-bar', 'pie', 'tree-map'],
    defaultChartType: 'vertical-bar',
    axisConfig: {
      categoryAxis: { dataKey: 'label' },
      valueAxes: [{
        label: t("label.count")
      }]
    },
    series: [
      {
        label: t("label.count"),
        key: 'count',
        colors: getAllColors(),
        showLegend: false
      }
    ],
    transformData: (response) => {
      return response?.data?.data;
    },
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
        allowedRanges: [
          'show-all',
          'today',
          'yesterday',
          'tomorrow',
          'this-week',
          'last-week',
          'last-month',
          'last-year',
          'last-7-days',
          'last-14-days',
          'last-30-days',
          'last-90-days',
          'custom'
        ]
      },
      department: { multiSelect: true },
      model: true
    },
    drilldown: {
      defaultChartType: 'vertical-bar',
      allowedChartTypes: ['vertical-bar', 'horizontal-bar', 'pie'],
      axisConfig: {
        categoryAxis: { dataKey: 'label' },
        valueAxes: [{
          label: t("label.entityCount", { entity: `${customCaptions.part || 'Part'}/${customCaptions.tool || 'Tool'}` })
        }]
      },
      series: [
        {
          label: t("label.entityCount", { entity: `${customCaptions.part || 'Part'}/${customCaptions.tool || 'Tool'}` }),
          key: 'count',
          showLegend: false
        }
      ],
      breadcrumbLabel: t("label.entityCount", { entity: `${customCaptions.part || 'Part'}/${customCaptions.tool || 'Tool'}` }),
      getParams: (dataPoint) => {
        return {
          missingPartToolId: dataPoint.id
        };
      }
    }
  };

  return (
    <ReportPage 
      title={chartConfig.title}
      chartConfig={chartConfig}
    />
  );
};

export default MissingPartsToolsReport; 
